/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: DL_1qvOfjvo7
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import SeparatorHorizontal from "../../SeparatorHorizontal"; // plasmic-import: vjwl8iKCk0Vg/component
import BottomNav from "../../BottomNav"; // plasmic-import: KUFcRsF9ovEF/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import OnboardingContainer from "../../OnboardingContainer"; // plasmic-import: KM-5MN7o_pvE/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: hEgWOAymJgYc/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: e3sNvwGa9YkJ/component
import FormElement from "../../FormElement"; // plasmic-import: SrXOXPt7amu2/component
import InputField from "../../InputField"; // plasmic-import: Vlgv2YqSKmv3/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicWebLogin.module.css"; // plasmic-import: DL_1qvOfjvo7/css
import image183TIq2GJx3VUp from "./images/image18.svg"; // plasmic-import: 3tIq2GJx3vUP/picture
import image2RcDhf2RmVmG from "./images/image2.svg"; // plasmic-import: RcDhf_2RMVmG/picture

createPlasmicElementProxy;

export const PlasmicWebLogin__VariantProps = new Array();

export const PlasmicWebLogin__ArgProps = new Array();

const $$ = {};

function PlasmicWebLogin__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "insideOnboarding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.insideOnboarding
      },
      {
        path: "onboardingContainer.showTerms",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "onboardingContainer.container",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "withForm"
      },
      {
        path: "usernameOrEmail",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "password",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "pswdState",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "userState",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "pswdHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "usernameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "pswdHelperOnOff",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "usernameHelperOnOff",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "loginOk",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => true
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageLogin"}
        data-plasmic-override={overrides.pageLogin}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageLogin
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <TabLayout
              data-plasmic-name={"tabLayout"}
              data-plasmic-override={overrides.tabLayout}
              className={classNames("__wab_instance", sty.tabLayout)}
              layoutType={"verticalStacked"}
              tabContent={
                <PageLayout
                  data-plasmic-name={"pageLayout"}
                  data-plasmic-override={overrides.pageLayout}
                  className={classNames("__wab_instance", sty.pageLayout)}
                  layoutSections={"withoutNav"}
                  pageContent={
                    <OnboardingContainer
                      data-plasmic-name={"onboardingContainer"}
                      data-plasmic-override={overrides.onboardingContainer}
                      buttonsWrapper={
                        <React.Fragment>
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__uYq3R
                            )}
                            color={"brand"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPWorkspace"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/platform/workspace`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPWorkspace"] != null &&
                                typeof $steps["goToPWorkspace"] === "object" &&
                                typeof $steps["goToPWorkspace"].then ===
                                  "function"
                              ) {
                                $steps["goToPWorkspace"] =
                                  await $steps["goToPWorkspace"];
                              }
                            }}
                          />

                          {false ? (
                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary__jCaeA
                              )}
                            />
                          ) : null}
                        </React.Fragment>
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.onboardingContainer
                      )}
                      container={generateStateValueProp($state, [
                        "onboardingContainer",
                        "container"
                      ])}
                      formWrapper={
                        <InputFormShell
                          data-plasmic-name={"inputFormShell"}
                          data-plasmic-override={overrides.inputFormShell}
                          actionsSlot={
                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary___9OokH
                              )}
                              color={"brand"}
                              content={"log in"}
                              name={"johnTheLogMaster"}
                              onClick={async () => {
                                const $steps = {};
                                $steps["runCode"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        customFunction: async () => {
                                          return (() => {
                                            let username = document
                                              .getElementById("username")
                                              .value.trim();
                                            let pswd = document
                                              .getElementById("pswd")
                                              .value.trim();
                                            console.log(
                                              "username: ",
                                              username,
                                              " password: ",
                                              pswd
                                            );
                                            return console.log($state.loginOk);
                                          })();
                                        }
                                      };
                                      return (({ customFunction }) => {
                                        return customFunction();
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["runCode"] != null &&
                                  typeof $steps["runCode"] === "object" &&
                                  typeof $steps["runCode"].then === "function"
                                ) {
                                  $steps["runCode"] = await $steps["runCode"];
                                }
                                $steps["sendToBackend"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        customFunction: async () => {
                                          return (async () => {
                                            return (async function () {
                                              const username = document
                                                .getElementById("username")
                                                .value.trim();
                                              const pswd = document
                                                .getElementById("pswd")
                                                .value.trim();
                                              console.log(
                                                "user/pswd: ",
                                                username,
                                                pswd
                                              );
                                              try {
                                                const response = await fetch(
                                                  "https://opformypractice.com/api/login/",
                                                  {
                                                    method: "POST",
                                                    headers: {
                                                      "Content-Type":
                                                        "application/json"
                                                    },
                                                    body: JSON.stringify({
                                                      username,
                                                      password: pswd
                                                    }),
                                                    credentials: "include"
                                                  }
                                                );
                                                if (response.ok) {
                                                  const data =
                                                    await response.json();
                                                  console.log(
                                                    "Login successful! Welcome " +
                                                      data.username
                                                  );
                                                  $state.loginOk = true;
                                                } else {
                                                  $state.loginOk = false;
                                                  const error =
                                                    await response.json();
                                                  console.log(
                                                    "Login failed: " +
                                                      error.detail
                                                  );
                                                  if (
                                                    error.detail ===
                                                    "Invalid username"
                                                  ) {
                                                    $state.usernameHelperOnOff = true;
                                                    $state.usernameHelperText =
                                                      "The username is wrong. Please try again";
                                                    $state.userState = "error";
                                                  } else if (
                                                    error.detail ===
                                                    "Invalid password"
                                                  ) {
                                                    $state.pswdHelperOnOff = true;
                                                    $state.pswdHelperText =
                                                      "The password is wrong. Please try again";
                                                    $state.pswdState = "error";
                                                  } else {
                                                    $state.pswdHelperOnOff = true;
                                                    $state.pswdHelperText =
                                                      "Something went wrong, please try again";
                                                    $state.pswdState = "error";
                                                  }
                                                }
                                              } catch (err) {
                                                console.error(
                                                  "Network error:",
                                                  err
                                                );
                                                console.log(
                                                  "Network error: " +
                                                    err.message
                                                );
                                              }
                                            })();
                                          })();
                                        }
                                      };
                                      return (({ customFunction }) => {
                                        return customFunction();
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["sendToBackend"] != null &&
                                  typeof $steps["sendToBackend"] === "object" &&
                                  typeof $steps["sendToBackend"].then ===
                                    "function"
                                ) {
                                  $steps["sendToBackend"] =
                                    await $steps["sendToBackend"];
                                }
                                $steps["goToPWorkspace"] = $state.loginOk
                                  ? (() => {
                                      const actionArgs = {
                                        destination: `/platform/workspace`
                                      };
                                      return (({ destination }) => {
                                        if (
                                          typeof destination === "string" &&
                                          destination.startsWith("#")
                                        ) {
                                          document
                                            .getElementById(
                                              destination.substr(1)
                                            )
                                            .scrollIntoView({
                                              behavior: "smooth"
                                            });
                                        } else {
                                          location.assign(destination);
                                        }
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["goToPWorkspace"] != null &&
                                  typeof $steps["goToPWorkspace"] ===
                                    "object" &&
                                  typeof $steps["goToPWorkspace"].then ===
                                    "function"
                                ) {
                                  $steps["goToPWorkspace"] =
                                    await $steps["goToPWorkspace"];
                                }
                              }}
                              showIcon={false}
                              size={"medium"}
                              ststus={"normal"}
                              type={"button"}
                            />
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.inputFormShell
                          )}
                          fieldsSlot={
                            <React.Fragment>
                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement__fHCc6
                                )}
                                formInputComponent={
                                  <InputField
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputField__tfAyV
                                    )}
                                    inputId={"username"}
                                    placeholder={``}
                                    status={"normal"}
                                    type={"text"}
                                    valueInput={(() => {
                                      try {
                                        return $state.usernameOrEmail;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return undefined;
                                        }
                                        throw e;
                                      }
                                    })()}
                                  />
                                }
                                helperText={(() => {
                                  try {
                                    return $state.usernameHelperText;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                                label={"*username or email."}
                                name={"usernameOrEmail"}
                                required={true}
                                showHelperText={(() => {
                                  try {
                                    return $state.usernameHelperOnOff;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })()}
                                status={(() => {
                                  try {
                                    return $state.userState;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "normal";
                                    }
                                    throw e;
                                  }
                                })()}
                              />

                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement__ju5AP
                                )}
                                formInputComponent={
                                  <InputField
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputField__rgCc0
                                    )}
                                    inputId={"pswd"}
                                    status={"normal"}
                                    type={"password"}
                                    valueInput={(() => {
                                      try {
                                        return $state.password;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return undefined;
                                        }
                                        throw e;
                                      }
                                    })()}
                                  />
                                }
                                helperText={(() => {
                                  try {
                                    return $state.pswdHelperText;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                                label={"*password."}
                                name={"password"}
                                required={true}
                                showHelperText={(() => {
                                  try {
                                    return $state.pswdHelperOnOff;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })()}
                                status={(() => {
                                  try {
                                    return $state.pswdState;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "normal";
                                    }
                                    throw e;
                                  }
                                })()}
                              />
                            </React.Fragment>
                          }
                          layout={"_default"}
                          onSubmit={async () => {
                            const $steps = {};
                            $steps["goToPWorkspace"] = true
                              ? (() => {
                                  const actionArgs = {
                                    destination: `/platform/workspace`
                                  };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToPWorkspace"] != null &&
                              typeof $steps["goToPWorkspace"] === "object" &&
                              typeof $steps["goToPWorkspace"].then ===
                                "function"
                            ) {
                              $steps["goToPWorkspace"] =
                                await $steps["goToPWorkspace"];
                            }
                            $steps["runCode"] = true
                              ? (() => {
                                  const actionArgs = {
                                    customFunction: async () => {
                                      return event => {
                                        try {
                                          // Don’t call event.preventDefault() unless you intentionally want to stop nav
                                          // Don’t throw; don’t return a React node, just do side-effects
                                          console.log("values", event.values);
                                          // do lightweight stuff only
                                        } catch (e) {
                                          console.error(e);
                                        }
                                      };
                                    }
                                  };
                                  return (({ customFunction }) => {
                                    return customFunction();
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["runCode"] != null &&
                              typeof $steps["runCode"] === "object" &&
                              typeof $steps["runCode"].then === "function"
                            ) {
                              $steps["runCode"] = await $steps["runCode"];
                            }
                          }}
                        />
                      }
                      infotextWrapper2={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__s0MwK
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {"Don't have an OP workspace account? "}
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-jyNQAasUGv4X)" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                data-plasmic-name={"link"}
                                data-plasmic-override={overrides.link}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.__wab_text,
                                  projectcss.plasmic_default__inline,
                                  sty.link
                                )}
                                href={`/signup`}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span"
                                    }
                                    style={{
                                      color: "var(--token-jyNQAasUGv4X)"
                                    }}
                                  >
                                    {"sign up free"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-jyNQAasUGv4X)" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      }
                      onContainerChange={async (...eventArgs) => {
                        generateStateOnChangeProp($state, [
                          "onboardingContainer",
                          "container"
                        ]).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onShowTermsChange={async (...eventArgs) => {
                        generateStateOnChangeProp($state, [
                          "onboardingContainer",
                          "showTerms"
                        ]).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      showHelperText={true}
                      showTerms={generateStateValueProp($state, [
                        "onboardingContainer",
                        "showTerms"
                      ])}
                      stepHeader={"welcome back!"}
                      text={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__m4VUb
                            )}
                          >
                            <React.Fragment>
                              <React.Fragment>
                                {"We\u2019ve sent a message with a link to "}
                              </React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ color: "#000000", fontWeight: 600 }}
                              >
                                {"john@email.com"}
                              </span>
                              <React.Fragment>
                                {" to verify your email."}
                              </React.Fragment>
                            </React.Fragment>
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__b9Pfl
                            )}
                          >
                            {
                              "This link expires in 24 hours.\nDidn't receive an email? Check your spam folder."
                            }
                          </div>
                        </React.Fragment>
                      }
                      text2={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ixe5S
                            )}
                          >
                            {"that\u2019s it, you\u2019re in."}
                          </div>
                          {false ? (
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__xfE8B
                              )}
                            >
                              {
                                "You\u2019ve successfully created you OP account."
                              }
                            </div>
                          ) : null}
                        </React.Fragment>
                      }
                    />
                  }
                />
              }
              tabNav={
                <React.Fragment>
                  <SeparatorHorizontal
                    data-plasmic-name={"separatorHorizontal"}
                    data-plasmic-override={overrides.separatorHorizontal}
                    className={classNames(
                      "__wab_instance",
                      sty.separatorHorizontal
                    )}
                  />

                  <BottomNav
                    data-plasmic-name={"bottomNav"}
                    data-plasmic-override={overrides.bottomNav}
                    className={classNames("__wab_instance", sty.bottomNav)}
                    nameWrapper={
                      <LeftSectionNav
                        data-plasmic-name={"leftSectionTopnav"}
                        data-plasmic-override={overrides.leftSectionTopnav}
                        bottomNav={"defaultOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.leftSectionTopnav
                        )}
                        topNav={"tabTitle"}
                      >
                        {"OP login."}
                      </LeftSectionNav>
                    }
                    navModule={
                      <ModuleNav
                        byPlacement={"navOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.moduleNav__yaOvn
                        )}
                        navButtonSlot={
                          <ButtonNav
                            className={classNames(
                              "__wab_instance",
                              sty.buttonNav__mCt0I
                            )}
                            color={"greyTwo"}
                            iconForButton={
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__p5PTq)}
                                displayHeight={"100%"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"none"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"100%"}
                                loading={"lazy"}
                                src={{
                                  src: image183TIq2GJx3VUp,
                                  fullWidth: 20,
                                  fullHeight: 20,
                                  aspectRatio: undefined
                                }}
                              />
                            }
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToWebHome"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/home` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToWebHome"] != null &&
                                typeof $steps["goToWebHome"] === "object" &&
                                typeof $steps["goToWebHome"].then === "function"
                              ) {
                                $steps["goToWebHome"] =
                                  await $steps["goToWebHome"];
                              }
                            }}
                            shape={"globalRounding"}
                            status={"normal"}
                          />
                        }
                      />
                    }
                    navModule2={
                      <ModuleNav
                        byPlacement={"navOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.moduleNav__jjOry
                        )}
                        navButtonSlot={
                          <ButtonNav
                            className={classNames(
                              "__wab_instance",
                              sty.buttonNav___2Jsc0
                            )}
                            iconForButton={
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img___22Ee7)}
                                displayHeight={"100%"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"none"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"100%"}
                                loading={"lazy"}
                                src={{
                                  src: image2RcDhf2RmVmG,
                                  fullWidth: 256,
                                  fullHeight: 256,
                                  aspectRatio: 1
                                }}
                              />
                            }
                            shape={"fullRounding"}
                            slotSize={"fillButton"}
                          />
                        }
                      />
                    }
                    type={"withRightModule"}
                  />
                </React.Fragment>
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageLogin: [
    "pageLogin",
    "appShell",
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  tabLayout: [
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "link"
  ],

  separatorHorizontal: ["separatorHorizontal"],
  bottomNav: ["bottomNav", "leftSectionTopnav"],
  leftSectionTopnav: ["leftSectionTopnav"],
  pageLayout: ["pageLayout", "onboardingContainer", "inputFormShell", "link"],
  onboardingContainer: ["onboardingContainer", "inputFormShell", "link"],
  inputFormShell: ["inputFormShell"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebLogin__ArgProps,
          internalVariantPropNames: PlasmicWebLogin__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebLogin__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageLogin") {
    func.displayName = "PlasmicWebLogin";
  } else {
    func.displayName = `PlasmicWebLogin.${nodeName}`;
  }
  return func;
}

export const PlasmicWebLogin = Object.assign(
  // Top-level PlasmicWebLogin renders the root element
  makeNodeComponent("pageLogin"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    separatorHorizontal: makeNodeComponent("separatorHorizontal"),
    bottomNav: makeNodeComponent("bottomNav"),
    leftSectionTopnav: makeNodeComponent("leftSectionTopnav"),
    pageLayout: makeNodeComponent("pageLayout"),
    onboardingContainer: makeNodeComponent("onboardingContainer"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicWebLogin
    internalVariantProps: PlasmicWebLogin__VariantProps,
    internalArgProps: PlasmicWebLogin__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP | login.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicWebLogin;
/* prettier-ignore-end */
